import { useEffect, useState } from 'react';

const MOBILE_BREAKPOINT = 640;
// matchMedia evaluates the viewport without the forced layout that reading innerWidth costs at mount.
// Negating Tailwind's sm query keeps fractional widths between 639 and 640px in sync with the CSS.
const MOBILE_MEDIA_QUERY = `not all and (min-width: ${MOBILE_BREAKPOINT}px)`;

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mobileMediaQueryList = window.matchMedia(MOBILE_MEDIA_QUERY);
    const syncIsMobile = () => setIsMobile(mobileMediaQueryList.matches);

    syncIsMobile();
    mobileMediaQueryList.addEventListener('change', syncIsMobile);

    return () => {
      mobileMediaQueryList.removeEventListener('change', syncIsMobile);
    };
  }, []);

  return isMobile;
};

export default useIsMobile;
